/* Floodlight · ss-ui.js (core) — header glass, reveals, off-screen pause, WhatsApp visibility, accordions,
   qty steppers, in-page anchors, route curtain, sticky buy bar */
(function () {
  'use strict';
  if (window.SS_LOADED_ui) return;
  window.SS_LOADED_ui = true;
  var SS = window.SS;
  if (!SS) return;
  var doc = document, html = doc.documentElement, C = SS.config || {};
  var RV = '.rv:not(.in), .rvs:not(.in), .rvw:not(.in)';

  /* ---------- reveals ---------- */
  var io = null, fallbackT = 0;
  var revealOn = html.classList.contains('rv-on') && !window.SS_RV_OFF && !SS.design && 'IntersectionObserver' in window;
  function reveal(el) {
    if (el.classList.contains('in')) return;
    el.classList.add('in');
    if (io) io.unobserve(el);
    SS.emit('reveal', { el: el });
  }
  function revealAll() { SS.qsa(RV).forEach(reveal); }
  function revealInView() {
    var vh = window.innerHeight || 900;
    SS.qsa(RV).forEach(function (el) { if (el.getBoundingClientRect().top < vh) reveal(el); });
  }
  function scan() {
    SS.qsa(RV).forEach(function (el) {
      if (el.__rvSeen) return;
      el.__rvSeen = true;
      if (io) io.observe(el); else reveal(el);
    });
  }
  function armFallback() {
    clearTimeout(fallbackT);
    fallbackT = setTimeout(function () {
      revealInView();
      if (doc.documentElement.scrollHeight <= window.innerHeight + 2) revealAll();
    }, 1500);
  }
  try {
    if (revealOn && !SS.reduced) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) reveal(en.target); });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      window.SS_RV = true;
      scan();
      armFallback();
    } else {
      html.classList.remove('rv-on');
    }
  } catch (err) {
    io = null;
    html.classList.remove('rv-on');
  }
  SS.reveal = reveal;
  SS.scanReveals = function () { if (html.classList.contains('rv-on')) { scan(); armFallback(); } };
  window.addEventListener('beforeprint', revealAll);
  SS.on('motion', function (d) { if (d.reduced) { html.classList.remove('rv-on'); revealAll(); } });

  /* ---------- infinite animations pause off-screen ---------- */
  var az = null;
  function pauseSvgs(el, play) {
    SS.qsa('svg', el).forEach(function (s) {
      try { if (play) s.unpauseAnimations(); else s.pauseAnimations(); } catch (e) {}
    });
  }
  if ('IntersectionObserver' in window) {
    az = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.classList.toggle('zzz', !en.isIntersecting);
        pauseSvgs(en.target, en.isIntersecting && !SS.reduced);
      });
    }, { rootMargin: '120px 0px' });
  }
  function scanAz() {
    SS.qsa('[data-az]').forEach(function (el) {
      if (el.__az) return;
      el.__az = true;
      if (az) az.observe(el);
      if (SS.reduced) pauseSvgs(el, false);
    });
  }

  /* ---------- WhatsApp button ---------- */
  var wa = null;
  function hasText(el) {
    var kids = el.childNodes;
    for (var i = 0; i < kids.length; i++) {
      var n = kids[i];
      if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim()) return true;
    }
    return false;
  }
  function setWa(hide) {
    if (!wa) return;
    if (wa.classList.contains('hide') === hide && wa.__waInit) return;
    wa.__waInit = true;
    wa.classList.toggle('hide', hide);
    if (hide) { wa.setAttribute('aria-hidden', 'true'); wa.setAttribute('tabindex', '-1'); if (doc.activeElement === wa) wa.blur(); }
    else { wa.removeAttribute('aria-hidden'); wa.removeAttribute('tabindex'); }
  }
  function checkWa() {
    wa = doc.getElementById('ss-wa');
    if (!wa) return;
    var vh = window.innerHeight || 900, iw = html.clientWidth || window.innerWidth || 1440;
    var hide = !!(SS.overlay && SS.overlay.current());
    if (!hide) hide = SS.qsa('[data-wa-hide]').some(function (el) { return el.getBoundingClientRect().bottom > vh * 0.55; });
    var ftr = doc.querySelector('.ftr');
    if (!hide && ftr && ftr.getBoundingClientRect().top < vh - 100) hide = true;
    if (!hide && doc.querySelector('[data-sticky-buy].on')) hide = true;
    var gap = iw <= 640 ? 16 : 26, m = 16;
    var w = wa.offsetWidth || 56, h = wa.offsetHeight || 56;
    var bx0 = iw - gap - w - m, by0 = vh - gap - h - m, bx1 = iw - gap, by1 = vh - 2;
    if (!hide && doc.elementsFromPoint) {
      var xs = [bx0, iw - gap - w + 6, iw - gap - w / 2, iw - gap - 6];
      var ys = [by0, vh - gap - h + 6, vh - gap - h / 2, vh - gap - 6, vh - gap + 6];
      outer: for (var a = 0; a < xs.length; a++) {
        for (var b = 0; b < ys.length; b++) {
          var x = xs[a], y = ys[b];
          if (x < 0 || y < 0 || y >= vh) continue;
          var els = doc.elementsFromPoint(x, y);
          for (var k = 0; k < els.length; k++) {
            var el = els[k];
            if (wa.contains(el) || !el.closest) continue;
            if (el.closest('.hdr, .toast')) continue;
            if (el.closest('button, select, input, textarea, a[href], label, .ftr-bottom, [data-wa-avoid]')) { hide = true; break outer; }
            if (hasText(el)) { hide = true; break outer; }
          }
        }
      }
    }
    if (!hide) {
      var probes = SS.qsa('[data-wa-probe]');
      for (var i = 0; i < probes.length && !hide; i++) {
        var r = probes[i].getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && (probes[i].textContent || '').trim() && r.left < bx1 && r.right > bx0 && r.top < by1 && r.bottom > by0) hide = true;
      }
    }
    setWa(hide);
  }
  SS.checkWa = checkWa;

  /* ---------- scroll frame ---------- */
  var hdr = null, raf = 0, settleT = 0;
  function frame() {
    raf = 0;
    var vh = window.innerHeight || 900;
    hdr = hdr && hdr.isConnected ? hdr : doc.getElementById('ss-hdr');
    if (hdr) hdr.classList.toggle('glass', (window.scrollY || html.scrollTop) > 30);
    if (io) SS.qsa(RV).forEach(function (el) { if (el.getBoundingClientRect().top < vh * 0.9) reveal(el); });
    var sticky = doc.querySelector('[data-sticky-buy]');
    if (sticky) {
      var anchor = doc.querySelector('[data-sticky-anchor]');
      var ft = doc.querySelector('.ftr');
      var past = !anchor || anchor.getBoundingClientRect().bottom < 92;
      var atFoot = !!ft && ft.getBoundingClientRect().top < vh - 40;
      var on = past && !atFoot;
      if (sticky.classList.contains('on') !== on) sticky.classList.toggle('on', on);
      if (on === sticky.hasAttribute('inert')) {
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      }
    }
    checkWa();
  }
  function onScroll() {
    clearTimeout(settleT);
    settleT = setTimeout(frame, 900);
    if (!raf) raf = requestAnimationFrame(frame);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  var teT = 0;
  doc.addEventListener('transitionend', function (e) {
    var w = doc.getElementById('ss-wa');
    if (!e.target || (w && w.contains(e.target))) return;
    clearTimeout(teT);
    teT = setTimeout(checkWa, 90);
  }, true);
  ['reveal', 'overlay:open', 'overlay:close', 'wa:check', 'cart:updated'].forEach(function (n) {
    SS.on(n, function () { clearTimeout(teT); teT = setTimeout(checkWa, 30); });
  });

  /* ---------- accordions ---------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-acc] .acc-btn');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var body = doc.getElementById(btn.getAttribute('aria-controls'));
    if (body) body.hidden = !open;
    SS.emit('wa:check', {});
  });

  /* ---------- generic qty steppers (cart lines are handled by ss-cart) ---------- */
  function clampQty(input, v) {
    var min = input.min !== '' ? Number(input.min) : 1;
    var max = input.max !== '' ? Number(input.max) : 99;
    v = Math.round(Number(v));
    if (isNaN(v)) v = min;
    return Math.max(min, Math.min(max, v));
  }
  SS.clampQty = clampQty;
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qty-step]');
    if (!b) return;
    var box = b.closest('[data-qty]');
    if (!box || box.hasAttribute('data-line-key')) return;
    var input = box.querySelector('.qty-in, input');
    if (!input) return;
    var next = clampQty(input, Number(input.value || 0) + Number(b.getAttribute('data-qty-step')));
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  doc.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('qty-in')) return;
    var box = input.closest('[data-qty]');
    if (!box || box.hasAttribute('data-line-key')) return;
    var v = clampQty(input, input.value);
    if (String(v) !== input.value) input.value = v;
  });

  /* ---------- in-page anchors + route curtain flag ---------- */
  function sameDoc(a) {
    return a.origin === location.origin && a.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
  }
  doc.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    if (!a.hash || !sameDoc(a)) return;
    var target = null;
    try { target = doc.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (err) { target = null; }
    if (!target) return;
    e.preventDefault();
    if (SS.overlay) SS.overlay.closeAll();
    target.scrollIntoView({ behavior: SS.reduced ? 'auto' : 'smooth', block: 'start' });
    try { history.replaceState(null, '', a.hash); } catch (err) {}
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (err) {}
  });
  window.addEventListener('click', function (e) {
    if (!C.curtain || SS.design || SS.reduced) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download') || a.hasAttribute('data-no-curtain')) return;
    if (a.origin !== location.origin || /^\/(checkout|account|cart\/(add|change|clear))/.test(a.pathname)) return;
    if (sameDoc(a) && (a.hash || a.search === location.search)) return;
    try { sessionStorage.setItem('ss-wipe', '1'); } catch (err) {}
  });
  function endCurtain() {
    if (!html.classList.contains('wipe-in')) return;
    setTimeout(function () { html.classList.remove('wipe-in'); }, 800);
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      html.classList.remove('wipe-in');
      try { sessionStorage.removeItem('ss-wipe'); } catch (err) {}
      if (SS.overlay) SS.overlay.closeAll();
    }
  });

  /* ---------- boot ---------- */
  function boot() {
    scan();
    scanAz();
    endCurtain();
    frame();
    setTimeout(checkWa, 400);
  }
  if (SS.domReady) boot(); else doc.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', function () { frame(); });
  SS.on('section:load', function () { scanAz(); SS.scanReveals(); if (SS.design) revealAll(); frame(); });
})();
